'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthMutation } from '@/api';
import { converter } from '../_utils/converter';
interface DonationReservationModalProps {
  opened: boolean;
  businessId?: number;
  productNumber?: string;
  onSuccess?: () => void;
  onClose?: () => void;
  description?: string;
}

/**
 * * 기부 사전예약 임시 모달
 */
export const DonationReservationModal = t0 => {
  const $ = _c(36);
  const {
    opened,
    businessId,
    productNumber,
    onSuccess,
    onClose,
    description
  } = t0;
  const {
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== businessId || $[1] !== productNumber) {
    t1 = AuthMutation["post:/wello/v2/auth/home/donation/reservation"]({
      body: {
        homeDonationBusinessId: businessId,
        productNumber
      }
    });
    $[0] = businessId;
    $[1] = productNumber;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onSuccess || $[4] !== queryClient) {
    t2 = () => {
      onSuccess?.();
      queryClient.invalidateQueries();
    };
    $[3] = onSuccess;
    $[4] = queryClient;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== toastError) {
    t3 = error => {
      toastError({
        error
      });
    };
    $[6] = toastError;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      ...t1,
      onSuccess: t2,
      onError: t3
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    mutate: createReservation,
    isPending: isCreatingReservation
  } = useMutation(t4);
  let t5;
  if ($[12] !== description) {
    t5 = converter.highlight(converter.sanitizeHTML(description ?? ""));
    $[12] = description;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const safeHighlightedDescription = t5;
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" className="size-55 shrink-0 text-Gray-500" aria-hidden={true}><path opacity="0.4" d="M40 16V24.92C40 25.33 39.604 25.602 39.21 25.48C38.04 25.116 36.792 24.96 35.478 25.01C29.908 25.26 25.26 29.91 25.01 35.48C24.95 36.8 25.11 38.04 25.48 39.21C25.6 39.61 25.33 40.0 24.918 40.0H10C6 40.0 4 38.0 4 34.0V16.0H40V16Z" fill="currentColor" /><path d="M34 7H31.5V4C31.5 3.172 30.828 2.5 30 2.5C29.172 2.5 28.5 3.172 28.5 4V7H15.5V4C15.5 3.172 14.828 2.5 14 2.5C13.172 2.5 12.5 3.172 12.5 4V7H10C6 7 4 9 4 13V16H40V13C40 9 38 7 34 7Z" fill="currentColor" /><path d="M14.04 26C12.94 26 12.03 25.104 12.03 24C12.03 22.896 12.92 22 14.02 22H14.04C15.15 22 16.04 22.896 16.04 24C16.04 25.104 15.14 26 14.04 26ZM24.04 24C24.04 22.896 23.15 22 22.04 22H22.02C20.92 22 20.03 22.896 20.03 24C20.03 25.104 20.94 26 22.04 26C23.14 26 24.04 25.104 24.04 24ZM16.04 32C16.04 30.896 15.15 30 14.04 30H14.02C12.92 30 12.03 30.896 12.03 32C12.03 33.104 12.94 34 14.04 34C15.14 34 16.04 33.104 16.04 32Z" fill="currentColor" /><path d="M36 28C31.582 28 28 31.582 28 36C28 40.418 31.582 44 36 44C40.418 44 44 40.418 44 36C44 31.582 40.418 28 36 28ZM38.85 38.85C38.65 39.04 38.4 39.14 38.14 39.14C37.89 39.14 37.63 39.04 37.43 38.85L35.292 36.71C35.104 36.52 35 36.264 35 35.998V32.998C35 32.446 35.448 31.998 36 31.998C36.552 31.998 37 32.446 37 32.998V35.584L38.85 37.43C39.24 37.83 39.24 38.46 38.85 38.85Z" fill="currentColor" /></svg>;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="font-700 text-Gray-900 typo-body3">기부 사전 예약 안내</p>;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== safeHighlightedDescription) {
    t8 = <div className="flex flex-col gap-12 px-12">{t7}<p className="font-400 text-Gray-700 typo-body4" dangerouslySetInnerHTML={{
        __html: safeHighlightedDescription
      }} /></div>;
    $[16] = safeHighlightedDescription;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="rounded-xsmall bg-Gray-50 p-20 font-600 text-Gray-900 typo-body4">사전 예약을 해두시면, 기부 서비스가 다시 열릴 때 알림톡으로 알려드려요.<br />이벤트와 세액공제 혜택은 실제 기부하는 시점을 기준으로 적용돼요.</p>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8) {
    t10 = <div className="flex flex-col gap-20">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== businessId || $[22] !== createReservation || $[23] !== productNumber) {
    t11 = () => createReservation({
      body: {
        homeDonationBusinessId: businessId,
        productNumber
      }
    });
    $[21] = businessId;
    $[22] = createReservation;
    $[23] = productNumber;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== isCreatingReservation || $[26] !== t11) {
    t12 = <Button className="w-full rounded-small" onClick={t11} loading={isCreatingReservation}>사전 예약 신청하기</Button>;
    $[25] = isCreatingReservation;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t12) {
    t13 = <div className="flex flex-col items-center gap-20 px-16 pb-16 pt-36">{t6}<div className="flex w-full flex-col gap-32">{t10}{t12}</div></div>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== isCreatingReservation || $[32] !== onClose || $[33] !== opened || $[34] !== t13) {
    t14 = <Modal opened={opened} onClose={onClose} className="max-h-[90%] rounded-xlarge p-0 mobile:w-full lg:max-h-[90%] lg:p-0" loading={isCreatingReservation}>{t13}</Modal>;
    $[31] = isCreatingReservation;
    $[32] = onClose;
    $[33] = opened;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};